module.exports = __webpack_public_path__ + "img/logo.929688c6.webp";